import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";

import { useForm } from "react-hook-form";
import "./login.scss";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import useApi from "../hooks/useApi";
import { login } from "../state/slice";
import { useDispatch } from "react-redux";
import Footer from "./footer/footer.component.jsx";

const Login = () => {
  const logo = require("../assets/world-cc-logo.svg")?.default;
  const newlogo = require("../assets/ask-tim-final-logo.jpg");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();

  const { post } = useApi();
  const [loginData, setLoginData] = useState<any>();
  const [customError, setCustomError] = useState<any>();

  const onSubmit = (data: any) => {
    setCustomError("");
    if (data?.username !== "" && data?.password !== "") {
      // console.log("hitting api1");
      const payload = {
        email: data?.username?.trim(),
        password: data?.password?.trim(),
      };
      authenticateUser(payload);
    }
  };
  useEffect(() => {
    initForm();
  }, [loginData]);

  const authenticateUser = async (payload: any) => {
    setCustomError("");
    const response: any = await post("users/authenticate", payload);
    // console.log(response);
    if (
      response?.data?.email &&
      response?.data?.name &&
      response?.data?.password
    ) {
      setLoginData(response.data);

      dispatch(login(response.data));
    } else {
      setCustomError(
        response?.response?.data?.detail || "Something went wrong !!",
      );
    }
  };
  const [passwordShown, setPasswordShown] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordShown(!passwordShown);
  };

  const renderForm = () => {
    return (
      <div className="logindiv">
        <div className="logos">
          <img className="mainLogo" src={logo} alt="world-cc-logo"></img>
          <img className="mainLogo2" src={newlogo} alt="world-cc-logo"></img>
        </div>

        <div className="login-container">
          <form onSubmit={handleSubmit(onSubmit)} className="login-form">
            <div className="form-group mb-3">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                id="username"
                data-testid="username"
                className="form-control"
                {...register("username", {
                  required: "Username is required",
                })}
                placeholder=""
              />
            </div>

            <div className="form-group mb-3 position-relative">
              <label htmlFor="password">Password</label>
              <input
                className="form-control"
                id="password"
                data-testid="password"
                {...register("password", {
                  required: "Password is required",
                })}
                type={passwordShown ? "text" : "password"}
                {...register("password")}
                placeholder=" "
              />

              <span
                data-testid="toggle"
                className="position-absolute top-50 end-0  pe-2"
                onClick={togglePasswordVisibility}
              >
                {passwordShown ? (
                  <span>
                    <span>{(FaEyeSlash as any)()}</span>
                  </span>
                ) : (
                  <span>{(FaEye as any)()}</span>
                )}
              </span>
            </div>
            <button className="btn loginbtn mb-3" type="submit" title="Login">
              Login
            </button>

            <span className="text-danger">
              {(errors?.username || errors?.password) && (
                <div>
                  {(
                    errors?.username?.message || errors?.password?.message
                  )?.toString()}
                </div>
              )}
              {!(errors?.username || errors?.password) && customError
                ? customError
                : ""}
            </span>
          </form>
        </div>

        <Footer />
      </div>
    );
  };
  const initForm = () => {
    if (loginData) {
      return <Navigate to="/dashboard" replace />;
    } else {
      return renderForm();
    }
  };

  return initForm();
};

export default Login;
